/**
 *
 * @parent SchoolInformation
 * @stateless
 */

import React, { PropTypes } from 'react';
import Form from 'components/Form';

import getSchoolDetail from 'controllers/school/getSchoolDetail';
import getSchoolTypes from 'controllers/school/getSchoolTypes';
import logoUploader from 'controllers/uploader/logoUploader';
import updateSchoolDetail from 'controllers/school/updateSchoolDetail';
import {updateSchoolInfo} from 'containers/Main/ducks/school-detail';
import './SchoolInformationForm.scss';
import getSchoolSettings from 'controllers/school/getSchoolSettings'
import updateSchoolSettings from 'controllers/school/updateSchoolSettings'
import { Button } from 'components/UI';
import Transition from 'components/UI/Transition'
import Loading from 'components/UI/Loading';
import { connect } from 'react-redux';
import __R, {userCan} from 'containers/__R';

const DEFAULT_REGION_CODE = 'ca';
const mapDispatchToProps = dispatch => {
  return {
    updateSchoolInfo: (schoolDetail) => dispatch(updateSchoolInfo(schoolDetail)),
  };
};

class SchoolInformationForm extends React.Component {

  constructor(props) {
    super(props);

    this.onSubmit = this.onSubmit.bind(this);
    this.getSchema = this.getSchema.bind(this);
    this.onChange = this.onChange.bind(this);
    this.onSettingChange = this.onSettingChange.bind(this);
    this.convertForForm = this.convertForForm.bind(this);
    this.updateSchool = this.updateSchool.bind(this);
    this.convertSettingsForFrontend = this.convertSettingsForFrontend.bind(this);
    this.convertSettingsForBackend = this.convertSettingsForBackend.bind(this);

    this.state = {
      formData: {phone_parsed: {country_code: '1', national_number: '', region_code : DEFAULT_REGION_CODE}},
      settingFormData: {},
      categories: [],
      fetching: false,
    }
  }

  getSchema() {
    const {
      categories,
    } = this.state;

    this.schema = [
      {
        name: 'logo',
        label: __('School Logo', 'schoolInformation.form'),
        type: 'imageUploader',
        options: {
          aspectRatioHeight: 1,
          aspectRatioWidth: 1,
        }
      },
      {
        name: 'title',
        label: __('School Name', 'schoolInformation.form'),
        type: 'text',
        required: false,
      },
      {
        name: 'description',
        label: __('About School', 'schoolInformation.form'),
        type: 'textarea',
        required: false,
      },
      {
        name: 'phone_parsed',
        label: __('School Phone Number', 'schoolInformation.form'),
        type: 'phone',
        required: false,
      },
      {
        name: 'email',
        label: __('School Email', 'schoolInformation.form'),
        type: 'email',
        required: false,
      },
      {
        name: 'timezone',
        label: __('Time Zone', 'schoolInformation.form'),
        type: 'text',
        required: false,
        disabled: true,
      },
      {
        name: 'homepage',
        label: __('School Website', 'schoolInformation.form'),
        type: 'text',
        required: false,
      },
      {
        name: 'categories',
        label: __('Class Categories', 'schoolInformation.form'),
        type: 'select',
        required: false,
        options: categories,
      },
      {
        name: 'ageLimitStr',
        label: __('Student Age', 'schoolInformation.form'),
        type: 'agelimit'
      },
      {
        name: 'addressStr',
        label: __('Address', 'schoolInformation.form'),
        type: 'address'
      },
      {
        name: 'openHours',
        label: __('Open Hours', 'schoolInformation.form'),
        type: 'openhours'
      },
    ];

    this.settingSchema = [
      {
        name: 'notification_convert_contact',
        label: __('Notify admin via email when contact converted to student', 'schoolInformation.form'),
        type: 'checkbox'
      },
    ]
  }

	componentWillMount() {
    let schoolId = localStorage.getItem('schoolId');

    this.setState({
      fetching: true,
    });

    getSchoolTypes().then((result)=>{
      const categories = result.map((type)=>{
        return {
          label: __(type.codename, 'schooltypes'),
          value: type.id,
        }
      });

      getSchoolSettings(schoolId).then((schoolSettings)=>{
          getSchoolDetail(schoolId).then((schoolInfo)=>{
            this.setState({
              fetching: false,
              formData: {
                ...schoolInfo,
              },
              settingFormData: schoolSettings,
              categories,
            })
          });
      });


    });
  }

  convertForForm(data) {
    const {
      title,
      description,
      phone,
      phone_parsed,
      email,
      timezone,
      openHours,
      logo,
      currency,
      address,
      suit_number,
      postcode,
      city,
      province,
      country,
      categories,
      homepage,
      enable,
      suitAgeLower,
      suitAgeUpper,
    } = data;

    const dataForForm = {
      title,
      description,
      phone,
      phone_parsed,
      email,
      timezone,
      openHours,
      logo,
      currency,
      categories,

      addressStr: {
        country,
        city,
        province,
        street: address,
        unit: suit_number,
        postalCode: postcode,
      },

      ageLimitStr: {
        min: suitAgeLower,
        max: suitAgeUpper,
      },

      // homepageStr: JSON.stringify({
      //   homepage,
      //   enable,
      // }),

    }

    return dataForForm;
  }

  convertForSubmit(data) {
    const {
      title,
      description,
      phone,
      phone_parsed,
      email,
      timezone,
      openHours,
      logo,
      currency,
      // schoolType,
      homepage,
      // categoriesStr,
      categories,
      addressStr,
      ageLimitStr,
    } = data;

    const schoolId = localStorage.getItem('schoolId');

    const dataForSubmit = {
      title,
      description,
      phone,
      phone_parsed,
      email,
      timezone,
      logo,
      // schoolType,

      country: addressStr.country,
      city: addressStr.city,
      province: addressStr.province,
      address: addressStr.street,
      suit_number: addressStr.unit,
      postcode: addressStr.postalCode,

      suitAgeLower: ageLimitStr.min,
      suitAgeUpper: ageLimitStr.max,

      categories,
      homepage,
      openHours,

      // These values below are not allow to submit yet
      // currency,
      // enable: homepageObj.enable,
    }

    return dataForSubmit;
  }
  
  convertSettingsForBackend(data){
    data.notification_convert_contact = data.notification_convert_contact == true ? 1 : 0;

    return data;
  }

  convertSettingsForFrontend(){
    const data = {
      ...this.state.settingFormData,
      notification_convert_contact: this.state.settingFormData.notification_convert_contact == 1 ? true : false,
    };

    return data;
  }

  beforeSubmit(data){

    const newData = {
      title: data.title,
      logo: data.logo,
      description: data.description,
      phone: data.phone_parsed.country_code.toString() + data.phone_parsed.national_number.toString(),
      email: data.email,
      homepage: data.homepage,
      categories: Array.isArray(data.categories) ? data.categories : [data.categories] ,
      suitAgeLower: data.suitAgeLower,
      suitAgeUpper: data.suitAgeUpper,
      country: data.country,
      city: data.city,
      province: data.province,
      address: data.address,
      suit_number: data.suit_number,
      postcode: data.postcode,
      openHours:data.openHours
    }

    return newData;
  }

  onSubmit() {
    const dataToSubmit = this.beforeSubmit(this.state.formData);
    const settingDataToSubmit = this.convertSettingsForBackend(this.state.settingFormData);
    const schoolId = localStorage.getItem('schoolId');

    this.setState({
      fetching: true,
    });

    if(dataToSubmit.logo.file){
      logoUploader(schoolId, dataToSubmit.logo.file)
      .then((res) => {
        if(res.result == 'success'){
          dataToSubmit.logo = res.save_to
          this.updateSchool(dataToSubmit)
        }
      })
      .catch((err) => {console.log(err)})
    } else {
      this.updateSchool(dataToSubmit, settingDataToSubmit)
    }
  }

  updateSchool(data, settingData){
    const schoolId = localStorage.getItem('schoolId');

    updateSchoolDetail(schoolId, data)
      .then((data)=>{
        this.setState({
          fetching: false,
          formData: data.updated,
        });
        if(data.result === 'success') {
          updateSchoolSettings(schoolId, settingData)
            .then((data)=>{
              this.props.updateSchoolInfo(data.updated)          
            });
        }
      })
      .catch((e)=>{


        this.setState({
          fetching: false,
        });
        console.error(e)
      });
  }

  onChange(newFormData) {
    this.setState({
      formData: {
        ...this.state.formData,
        ...this.convertForSubmit(newFormData),
      },
    });
  }
  
  onSettingChange(newFormData) {
    this.setState({
      settingFormData: {
        ...this.state.settingFormData,
        ...newFormData,
      },
    });
  }

  render() {
    const {
      formData,
      fetching,
    } = this.state;

    this.getSchema();

    if (fetching) {
      return <Loading onPanel={true}/>
    }

    return (
      <Transition>
        <div className='school-information-form-wrapper'>
          <div className='title-section'>
            <h1>{__("School Information", "schoolInformation", null, true)}</h1>
            <h4>{__("Add all information that will help your target audience better understand your school on our Yellow Pages advertisements", "schoolInformation")}</h4>
          </div>
          <Form
            onChange={this.onChange}
            schema={this.schema}
            formData={this.convertForForm(formData)}
            formStyle='inline'
            getValidationRef={this.props.getValidationRef}
          />
          <Form
            onChange={this.onSettingChange}
            schema={this.settingSchema}
            formData={this.convertSettingsForFrontend()}
            formStyle='inline'
            getValidationRef={this.props.getValidationRef}
          />

          <div className='submit-field'>
            <__R can='edit_school_setting' by='alert'>
              <Button disabled={fetching} bsStyle='primary' onClick={this.onSubmit}>{__('Update Info', 'schoolInformation.form')}</Button>
            </__R>
          </div>
        </div>
      </Transition>
		);
	}
}

export default connect(null,mapDispatchToProps)(SchoolInformationForm)



// WEBPACK FOOTER //
// ./src/containers/pages/SchoolInformation/SchoolInformationForm.js